import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getEffectList({ commit }) {
    try {
      const { records } = (await API.get('/connections/effect/getList')).data.data;
      commit(FILL_LIST, { records });
    } catch (err) {
      console.log(err);
    }
  },
};
